// extracted by mini-css-extract-plugin
export var dividerWithText = "index-module--dividerWithText--72061";